import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import GridCellBase from 'src/components/GridCellBase';
import Button from 'src/components/design-system/Button';
import { ManageSupplier } from 'src/types/manage-suppliers/ManageSupplier';
import { stopPropagation } from 'src/utils';
import { useContextSelector } from 'use-context-selector';
import { SuppliersContext } from '../SuppliersContext';
import { canEditSupplierInGrid } from '../utils/supplierInfoPermissions';

const SupplierInfoCell = (props: GridCellProps) => {
  const { t } = useTranslation();
  const dataItem = props.dataItem as ManageSupplier;
  const openEditSupplierPanel = useContextSelector(
    SuppliersContext,
    (context) => context.openEditSupplierPanel
  );
  const canManageSuppliers = useContextSelector(
    SuppliersContext,
    (context) => context.canManageSuppliers
  );
  const canManageTransmissionSettings = useContextSelector(
    SuppliersContext,
    (context) => context.canManageTransmissionSettings
  );

  const showEditLabel = canEditSupplierInGrid(
    dataItem,
    canManageSuppliers,
    canManageTransmissionSettings
  );

  const handleClick = useCallback(
    (e: MouseEvent) => {
      stopPropagation(e);
      openEditSupplierPanel(dataItem);
    },
    [dataItem, openEditSupplierPanel]
  );

  return (
    <GridCellBase {...props} disableToolTip>
      <div className="flex items-stretch w-full h-full justify-center px-2">
        <Button
          type="button"
          color="info"
          onClick={handleClick}
          size="sm"
          className="w-[60px] text-[12px]"
        >
          {showEditLabel ? t('Edit') : t('View')}
        </Button>
      </div>
    </GridCellBase>
  );
};

export default SupplierInfoCell;
